import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

type IPaygLimitModalType = 'numbers' | 'inboxes' | 'members'

export class PaygLimitModalStore {
  private _modalId = 'paygNumbersLimit_modal'
  private _type: IPaygLimitModalType | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get title() {
    return `You have reached the limit of 1 ${this._getEntityText} on Pay As You Go plan`
  }

  private get _getEntityText() {
    if (this._type === 'inboxes') {
      return 'inbox'
    }
    if (this._type === 'members') {
      return 'member'
    }
    return 'number'
  }

  get description() {
    if (this.isAdminOrOwnerRole) {
      return 'Upgrade to remove the limits'
    }

    return 'To remove the limits, please ask one of your admins to upgrade.'
  }

  get action() {
    return {
      text: 'Upgrade plan',
      onAction: () => {
        uiStore.changeRouteViaVue({
          path: `/${BillingPath.upgrade}`,
        })
        this.onClose()
      },
    }
  }

  open = async (type: IPaygLimitModalType) => {
    if (!this._entities.subscriptionStore.isPAYGPlan) return

    this._type = type

    if (this.isAdminOrOwnerRole) {
      modalStore.addModal({
        id: this._modalId,
        type: ModalTypeList.INFO,
        title: this.title,
        desc: this.description,
        primaryAction: this.action,
        secondaryAction: {
          text: 'Cancel',
          onAction: () => {
            this.onClose()
          },
        },
      })
    } else {
      modalStore.addModal({
        id: this._modalId,
        type: ModalTypeList.INFO,
        title: this.title,
        desc: this.description,
        infoModalTextAction: 'Done',
      })
    }
  }

  onClose = () => {
    modalStore.closeModal(this._modalId)
  }

  get isAdminOrOwnerRole() {
    return this._entities.usersStore.user?.isAdminOrOwnerRole
  }
}
